import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as GroupId } from '../../../../../../whole-house/canvas/group/Id';

const BulkUpdateGroup = intersect(
	struct({
		id: GroupId,
		name: string,
		layerIds: array(iotsUtils.UUID),
	})
)(
	partial({
		parentId: GroupId,
	})
);

export const Request = struct({
	groups: array(BulkUpdateGroup),
});
